module.exports = __webpack_public_path__ + "img/icon-grid.d54b4f70.svg";